export const useLocaleUtils = () => {
  const { availableLocales, defaultLocale } = useNuxtApp().$i18n

  const getSafeLocale = (locale: string) =>
    availableLocales.includes(locale as (typeof availableLocales)[number])
      ? (locale as (typeof availableLocales)[number])
      : defaultLocale

  const normalizeLocale = (locale: string) => getSafeLocale(locale.split('-')[0])

  const isLocaleSupported = (locale: string) =>
    availableLocales.includes(locale as (typeof availableLocales)[number])

  return {
    getSafeLocale,
    isLocaleSupported,
    normalizeLocale,
  }
}
